export class Person {
  name: string;
  status: string;
  avatar: string
}
